import uuid from "react-native-uuid";

export const generateUUID = () => uuid.v4();
